(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-sticky-filters"] && !Shopify.designMode) return;
  try {
    
  /* --- STICKY BEHAVIOR (JavaScript) --- */
  const filterBar = document.getElementById('CustomFilterBar');
  const section = document.getElementById('StickyFilterSection');

  function handleSticky() {
    // Get the position of the filter section relative to the viewport
    const rect = section.getBoundingClientRect();

    // Check if the top of the section has scrolled past the top of the viewport
    if (rect.top <= 0) {
      filterBar.classList.add('sticky-top');
      // Add padding to the content below the bar to prevent jumping
      section.style.paddingTop = `${filterBar.offsetHeight}px`;
    } else {
      filterBar.classList.remove('sticky-top');
      section.style.paddingTop = '0';
    }
  }

  // Use a passive listener for better scroll performance
  window.addEventListener('scroll', handleSticky, { passive: true });
  window.addEventListener('resize', handleSticky, { passive: true });
  
  // Initial check in case the user reloads while scrolled
  document.addEventListener('DOMContentLoaded', handleSticky);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
